import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import Button from '@material-ui/core/Button';
import {useDispatch, useSelector} from "react-redux";
import {
  postNewAttackOnDemand,
} from "../../../actions";
import red from "@material-ui/core/colors/red";
import {Tooltip} from "@material-ui/core";
import BBIconRocketSharp from "../../../assets/bbCustomIcons/BBIconRocketSharp";
import BBIconRocketSharpAgainRedo from "../../../assets/bbCustomIcons/BBIconRocketSharpAgainRedo";
import BBIconRocketSharpAdd from "../../../assets/bbCustomIcons/BBIconRocketSharpAdd";

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    // margin: theme.spacing(1),
    position: 'relative',
  },
  color1: {
    backgroundColor: green[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  color2: {
    backgroundColor: red[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -7,
    left: -7,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '55%',
    left: '55%',
    marginTop: -15,
    marginLeft: -16,
  },
});

const FormButton = (props) => {

  const {classes, customerId, attackPackageId, iconVariant = 1, justAdded = false} = props;
  // const {customers,} = useSelector(({customer}) => customer);
  const {loadingPostNewRequestedAttack, loadingPostNewRequestedAttackFail} = useSelector(({insider}) => insider);
  const [localLoading, setLocalLoading] = useState(false);
  // const isAssessmentsLoaded = bbIsObject(assessments) ? bbIsObject(assessments[complianceStandardId]) ? bbIsObject(assessments[complianceStandardId][controlId]) ? assessments[complianceStandardId][controlId] : null : null : null;

  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("printing complianceTogglesLoading, ", complianceTogglesLoading);
    //check for this customer and this target's loader.
    const isLoading = loadingPostNewRequestedAttack[attackPackageId] ? loadingPostNewRequestedAttack[attackPackageId] : null;
    const isError = loadingPostNewRequestedAttackFail[attackPackageId] ? loadingPostNewRequestedAttackFail[attackPackageId] : null;

    if (!isLoading || isError) {
      setLocalLoading(false);
    }
  }, [dispatch, loadingPostNewRequestedAttack, loadingPostNewRequestedAttackFail, attackPackageId]);

  const handleButtonClick = () => {
    if (!localLoading) {

        setLocalLoading(true);

        dispatch(postNewAttackOnDemand(
            {
              "customerId": customerId,
              "attackPackageId": attackPackageId,
            }));
    }
  };

  const assessmentPropertyIconArray = () => {
    //show three icons/buttons, but only one can be illuminated, and the other two can be clicked.
    // console.log("creating array of buttons for control ", controlId, "state:", assessmentPropertyState)

    let iconToUse = <BBIconRocketSharp />;
    let tipTitle = "Request Attack | Once requested, this attack will be provisioned by our attack infrastructure and then queued in the Insider Threat Status Log for your use."
    switch(iconVariant) {
      case 1:
        iconToUse = <BBIconRocketSharpAdd />
        tipTitle = "Request Attack | Once requested, this attack will be provisioned by our attack infrastructure and then queued in the Insider Threat Status Log for your use."
        break;

      case 2:
        iconToUse = <BBIconRocketSharpAgainRedo />
        tipTitle = "Re-attack | Order this same type of attack again."
        break;

      default:
        iconToUse = <BBIconRocketSharp />
        break;
    }



    //not met is a targetPropertyState of 1
    const requestAttackButton =
        <Tooltip title={tipTitle}>
            <Button
                variant="outlined"
                color="default"
                disableElevation
                className={`text-electric-blue ${justAdded ? "btn-floating pulse pulse-single" : ""}`}
                onClick={() => handleButtonClick()}
                disabled={localLoading}
            >
              <div className={classes.wrapper}>
                 {localLoading && <CircularProgress size={28} disableShrink className={classes.buttonProgress}/>}
                {iconToUse}
              </div>
            </Button>
        </Tooltip>

    // return <>
    //   {notMetButton}
    //   {partiallyMetButton}
    //   {fullyMetButton}
    // </>

    return requestAttackButton
  }

  // const buttonClassname = classNames({
  //   // [classes.color1]: flipColorLogic? !userPropertyState : userPropertyState,
  //   [classes.color2]: flipColorLogic? targetPropertyState : !targetPropertyState,
  // });

  return (
      <div className={`${classes.root}`}>
        {assessmentPropertyIconArray()}
      </div>

  );

}

FormButton.propTypes = {
  classes: PropTypes.object.isRequired,
  customerId: PropTypes.string.isRequired,
  attackPackageId: PropTypes.string.isRequired,
  iconVariant: PropTypes.number,
  justAdded: PropTypes.bool
};

export default withStyles(styles)(FormButton);